import React, { Component } from 'react';
import _ from 'lodash';
import {BootstrapTable, TableHeaderColumn} from 'react-bootstrap-table';
import { Link } from 'react-router-dom';

import './stylesheets/OrderDocumentsPage.css';

import { thaiDateFormatter, rowClassNameFormat, renderShowsTableTotal } from '../../utils/bootstrapTableFormatters';
import { MergeAttributes } from '../../components/FlatData';
import Loading from '../../components/Loading';
import Permission from '../../components/Permission';
import DocumentTypeFilter from '../../components/documents/filters/DocumentTypeFilter';
import BookedIssueNumberModal from '../../components/documents/BookedIssueNumberModal';

import SimpleModal from '../../components/SimpleModal';
import IssueNumberStore from '../../stores/IssueNumberStore';

import WorkflowProcessHistory from '../../components/WorkflowProcessHistory';
import OrderFilter from '../../components/documents/filters/OrderFilter';

class OrderDocumentsPage extends Component {
  constructor(props){
    super(props)

    this.state = {
      loading: true,
      open: false,
      group_id: '',
      amount: 1,
      topic: '',
      issue_numbers: [],
      groups: [],
      years: [],
      show_warning: false,
      edit_booked_id: '',
      allow_remove_ids: [],
      pagination: {},
      searchText: '',
      active_order: 'ทั้งหมด',
      selectedNumberType: "คำสั่ง"
    }

    this.handleBook = this.handleBook.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.renderOption = this.renderOption.bind(this);
    this.renderNumberTypeOption = this.renderNumberTypeOption.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.confirm = this.confirm.bind(this);
    this.onClose = this.onClose.bind(this);
    this.loadData = this.loadData.bind(this);
    this.redirectToShowDocumentPage = this.redirectToShowDocumentPage.bind(this);
    this.stateFormatter = this.stateFormatter.bind(this);
    this.openStateModal = this.openStateModal.bind(this);
    this.onCloseStateModal = this.onCloseStateModal.bind(this);
    this.onChange = this.onChange.bind(this);
    this.numberWithReservation = this.numberWithReservation.bind(this);
    this.onUpdateBooked = this.onUpdateBooked.bind(this);
    this.handleUpdateBooked = this.handleUpdateBooked.bind(this);
    this.openFullScreenHistory = this.openFullScreenHistory.bind(this);

    // Pagination & Search
    this.handlePageChange = this.handlePageChange.bind(this);
    this.handleSearchChange = this.handleSearchChange.bind(this);
    this.handleChangeOrder = this.handleChangeOrder.bind(this);
  }

  componentDidMount() {
    this.loadData();
  }

  loadData(){
    IssueNumberStore.request({url: `issue_numbers?page=1&type=คำสั่ง`}).then((resp)=>{
      const issue_numbers = _.get(resp.data, 'data', []);
      const groups = _.get(resp.data, 'included.groups', []);
      const years = _.get(resp.data, 'included.years', []);
      const allow_remove_ids = _.get(resp.data, 'included.allow_remove_ids', []);
      const pagination = _.get(resp.data, 'meta.pagination', {});

      let group_id = '';
      if (!_.isEmpty(groups)){
        group_id = _.first(groups).id;
      }

      this.setState({
        issue_numbers: issue_numbers,
        groups: groups,
        group_id: group_id,
        years: years,
        allow_remove_ids: allow_remove_ids,
        pagination: pagination
      })
    }, function(error){
      var error_message = _.get(error.response.data, 'error.message', '');
      alert(error_message)
    }).then(()=>{
      this.setState({loading: false});
    })
  }

  confirm(){
    this.setState({show_warning: true});
  }

  handleSubmit(){
    IssueNumberStore.save(null, {
      issue_number: {
        for_group_id: this.state.group_id,
        amount: this.state.amount,
        type: this.state.selectedNumberType,
        topic: this.state.topic
      }
    }).then((resp)=>{
      this.setState({open: false, show_warning: false, amount: 1, edit_booked_id: ''}, this.loadData());
    }, function(error){
      var error_message = _.get(error.response.data, 'error.message', '');
      alert(error_message)
    })
  }

  handleBook(){
    this.setState({open: true, amount: 1, topic: ''});
  }

  renderOption(group, index){
    return (
      <option key={index} value={group.id}>{group.attributes.name}</option>
    )
  }

  renderNumberTypeOption(type_name, index){
    return (
      <option key={`number_type_${index}`} value={type_name}>{type_name}</option>
    )
  }

  handleChange(event){
    let field_name = event.target.name;
    let value = event.target.value;
    this.setState({
      [field_name]: value
    })
  }

  handleDelete(issue_number){
    if (!window.confirm('ยืนยันยกเลิกการจอง')) { return }
    IssueNumberStore.request({id: issue_number.id, method: 'delete'}).then(()=>{
      this.loadData();
    }, function(error){
      var error_message = _.get(error.response.data, 'error.message', '');
      alert(error_message)
    })
  }

  numberWithReservation(cell, row){
    const allow_remove_ids = this.state.allow_remove_ids;

    return (
      <div>
        {row.available ? (
          <div>
            <i className="fa fa-pencil mr-2" aria-hidden="true" onClick={() => this.onUpdateBooked(cell, row)}></i>
            {row.number}<br />
            <div className='xxs-small text-warning'>{row.booked_by_user_name}</div>
            {_.includes(allow_remove_ids, row.id) && (
              <button 
                type='button' 
                className='btn btn-sm btn-warning'
                onClick={this.handleDelete.bind(this, row)}>
                ยกเลิกการจอง
              </button>
            )}
          </div>
        ) : (
          <div>{row.number}</div>
        )}
      </div>
    )
  }

  onUpdateBooked(cell, row){
    IssueNumberStore.request({id: row.id}).then((resp)=>{
      const topic = _.get(resp.data, 'data.attributes.topic', '');
      this.setState({
        open: true,
        edit_booked_id: row.id,
        show_warning: false,
        amount: 1,
        topic: topic
      });
    }, function(error){
      var error_message = _.get(error.response.data, 'error.message', '');
      alert(error_message)
    });
  }

  handleUpdateBooked() {
    IssueNumberStore.save(this.state.edit_booked_id, {
      issue_number: {
        topic: this.state.topic
      }
    }).then((resp)=>{
      this.setState({open: false, show_warning: false, amount: 1, edit_booked_id: ''}, this.loadData());
    }, function(error){
      var error_message = _.get(error.response.data, 'error.message', '');
      alert(error_message)
    });
  }

  onClose(){
    this.setState({
      open: false, 
      show_warning: false, 
      amount: 1,
      edit_booked_id: ''
    });
  }

  stateFormatter(cell, row) {
    const workflow_process_id = _.get(row, "document_detail.workflow_process_id");
    

    let status = cell;
    
    if(cell === "เอกสารส่งออก") {
      status = "จบการทำงานรอดำเนินการต่อไป"
    }

    return (
      <div>
        {workflow_process_id && (
          <a href="#" onClick={this.openStateModal.bind(this, workflow_process_id)}>
            {status}
          </a>
        )}
      </div>
    )
  }

  openStateModal(workflow_process_id, event){
    event.stopPropagation();

    this.setState({
      stateModalOpen: true,
      workflow_process_id: workflow_process_id,
    });
  }

  onCloseStateModal(){
    this.setState({
      stateModalOpen: false, 
      workflow_process_id: null
    });
  }

  redirectToShowDocumentPage(row, isSelected, e){
    if (_.isEmpty(row.document_detail)) { return }
      
    const { document_id, document_template_id, workflow_process_id } = row.document_detail;

    if (!_.isEmpty(document_id) && !_.isEmpty(document_template_id) && !_.isEmpty(workflow_process_id)){
      this.props.history.push(`/templates/documents/${document_id}/show/${document_template_id}/wp/${workflow_process_id}`);
    }
  }

  onChange(fieldname, value){
    this.setState({
      [fieldname]: value
    })
  }

  _setTableOption(){ 
    if(!this.state.loading){
      return "ไม่มีข้อมูล";
    }else{
      return <Loading />
    }
  }

  handlePageChange(page, sizePerPage){
    this.setState({isDataFetched: false, issue_numbers: []});
    const { searchText } = this.state;

    IssueNumberStore.request({url: `issue_numbers?page=${page}&searchText=${searchText}`}).then((resp)=>{
      const issue_numbers = _.get(resp.data, 'data', []);
      const pagination = _.get(resp.data, 'meta.pagination', {});

      this.setState({
        issue_numbers: issue_numbers,
        pagination: pagination
      });
    }).then(()=>{
      this.setState({isDataFetched: true});
    })
  }

  handleSearchChange(searchText){
    if (searchText.length === 1) { return }
    this.setState({isDataFetched: false, issue_numbers: []});

    IssueNumberStore.request({url: `issue_numbers?page=1&searchText=${searchText}&type=${this.state.active_type}`}).then((resp)=>{
      const issue_numbers = _.get(resp.data, 'data', []);
      const pagination = _.get(resp.data, 'meta.pagination', {});

      this.setState({
        issue_numbers: issue_numbers,
        pagination: pagination,
        searchText: searchText
      });
    }).then(()=>{
      this.setState({isDataFetched: true});
    })
  }

  handleChangeOrder(type){
    this.setState({isDataFetched: false, issue_numbers: []});

    IssueNumberStore.request({url: `issue_numbers?page=1&searchText=${this.state.searchText}&type=${type}`}).then((resp)=>{
      const issue_numbers = _.get(resp.data, 'data', []);
      const pagination = _.get(resp.data, 'meta.pagination', {});

      this.setState({
        issue_numbers: issue_numbers,
        pagination: pagination,
        active_order: type
      });
    }).then(()=>{
      this.setState({isDataFetched: true});
    })
  }
  
  openFullScreenHistory(){
    this.props.history.push(`/full_history/${this.state.workflow_process_id}`);
  }

  render() {
    const total_items_count = _.get(this.state.pagination, 'total_items_count', 0);
    const active_page = _.get(this.state.pagination, 'active_page', 1);

    const options = {
      sizePerPageList: [],
      sizePerPage: 20,
      page: active_page,
      noDataText: this._setTableOption(),
      onRowClick: this.redirectToShowDocumentPage,
      onPageChange: this.handlePageChange,
      onSearchChange: this.handleSearchChange,
      searchDelayTime: 500,
      paginationShowsTotal: renderShowsTableTotal
    };
    var data = [];
    if (!this.state.loading && !_.isEmpty(this.state.issue_numbers)){
      data = MergeAttributes(this.state.issue_numbers);
    }

    let modalTitle = 'ระบุจำนวนเอกสารที่ต้องการจอง';
    if (this.state.show_warning){
      modalTitle = 'เตือน';
    }

    const group = _.find(this.state.groups, {id: this.state.group_id});

    let issueNumberTypes = ["คำสั่ง"];
    if(Permission.canReceiveDocument()){
      issueNumberTypes = ["คำสั่ง"];
    }

    return (
      <div>
        <div className='row'>
          <div className='col-md-6'>
            <h4>ทะเบียนคุมคำสั่ง</h4>
          </div>
          <div className='col-md-6 text-right'>
            {Permission.canBookNumber() && (
              <button type='button' className='btn btn-info' onClick={this.handleBook}>จองเลข</button>
            )}
            <Link to='/templates' className='btn btn-success ml-1'>ร่างเอกสาร</Link>
          </div>
        </div>
        
        {/*
        <OrderFilter active_order={this.state.active_order} handleChangeOrder={this.handleChangeOrder} />
        */}

        <div className="rui-sendalldoc">
          <BootstrapTable 
            data={data}
            remote={ true }
            fetchInfo={{dataTotalSize: total_items_count}}
            search={ true }
            multiColumnSearch={ true }
            options={ options }
            striped
            hover
            pagination
            version='4'
            tableContainerClass={'table-sm'}
            trClassName={`${rowClassNameFormat} xs-small`}>
            <TableHeaderColumn isKey dataField='id' hidden></TableHeaderColumn>
            <TableHeaderColumn dataField='code' dataSort={ true } width='80'>เลขคำสั่ง</TableHeaderColumn>
            <TableHeaderColumn dataField='number' dataFormat={this.numberWithReservation} dataSort={ true } width='150'>ที่</TableHeaderColumn>
            <TableHeaderColumn dataField='ordered_date' dataSort={ true } width='130'>ลงวันที่</TableHeaderColumn>
            <TableHeaderColumn dataField='from_department' columnTitle dataSort={ true }>ออกโดย</TableHeaderColumn>
            <TableHeaderColumn dataField='topic' columnTitle dataSort={ true }>เรื่อง</TableHeaderColumn>
            <TableHeaderColumn dataField='type_name' width='70'>ประเภท</TableHeaderColumn>
            <TableHeaderColumn dataField='current_state_name' dataSort={ true } dataFormat={this.stateFormatter}>สถานะ</TableHeaderColumn>
          </BootstrapTable>
        </div>

        <BookedIssueNumberModal 
          group={group}
          modalTitle={modalTitle}
          onClose={this.onClose}
          confirm={this.confirm}
          selectedNumberType={this.state.selectedNumberType}
          handleChange={this.handleChange}
          issueNumberTypes={issueNumberTypes}
          renderNumberTypeOption={this.renderNumberTypeOption}
          renderOption={this.renderOption}
          handleSubmit={this.handleSubmit}
          handleUpdateBooked={this.handleUpdateBooked}
          {...this.state} 
          {...this.props} />

        <SimpleModal 
          isOpen={this.state.stateModalOpen}
          title="ประวัติการดำเนินการ"
          size={'modal-lg'}
          showSubmitButton={false}
          onClose={this.onCloseStateModal}>
            <WorkflowProcessHistory id={this.state.workflow_process_id} />

            <div className="modal-footer row">
              <button type='button' className="btn btn-primary pointer" onClick={this.openFullScreenHistory}>ดูแบบเต็มหน้าจอ</button>
              <button type='button' className="btn btn-secondary pointer" onClick={this.onCloseStateModal}>ปิด</button>
            </div>
        </SimpleModal>
      </div>
    )
  }
}

export default OrderDocumentsPage;


// WEBPACK FOOTER //
// ./src/pages/documents/OrderDocumentsPage.js